// Getform is being used to handle email receipt and delivery from the contact
// page.
export const GETFORM_FORM_ENDPOINT =
    "https://getform.io/f/29248390-b4c6-4caa-8a42-1f51c21817d1";
